import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { AppUrls } from '../app-urls';
import { CaptchaService } from '../services/captcha.service';

/** Обработчик по добавлению заголовков запросов. */
@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  private readonly rtsHostEnding: string = "rts-tender.ru";

  constructor(
    private _captchaService: CaptchaService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.headers.has('Content-Type')) {
      req = req.clone({headers: req.headers.set('Content-Type', 'application/json')});
    }

    let sendCredentials = req.withCredentials;

    if (!sendCredentials) {
      try {

        const host = this.getHost(req.url);
        if (host.endsWith(this.rtsHostEnding)) {
          sendCredentials = true;
        }

      } catch (e) {
      }
    }

    req = req.clone(
      {
        headers: req.headers
          .set('Accept', 'application/json')
          .set('X-Client-App', 'Angular')
          .set('X-Api-Request', 'True'),

        withCredentials: sendCredentials
      });

    const captchaTargetUrls = [
      AppUrls.offerPriceListItem.save,
      AppUrls.offerPriceListItem.publish,
      AppUrls.drugPriceListItem.save,
      AppUrls.drugPriceListItem.publish,
    ];

    if (captchaTargetUrls.some(url => req.url.includes(url))) {
      const token = this._captchaService.captchaToken$;
      const header = this._captchaService.captchaHeader$;

      if (token && header) {
        req = req.clone({
          headers: req.headers.set(header, token),
          withCredentials: sendCredentials
        });
      }
    }

    return next.handle(req);
  }

  /** IE не поддерживает URL */
  private getHost(url: string): string {
    try {
      let link = document.createElement('a');
      link.href = url;

      // Split чтобы убрать порт
      return link.host ? link.host.split(':')[0] : '';

    } catch (e) {
      return '';
    }
  }
}
